angular.module('leanlaw').controller('TrustPaymentCtrl', ['$scope', '$state', '$stateParams', 'accountingService', 'userService', 'leanLawApi', 'matterManager', function ($scope, $state, $stateParams, accountingService, userService, leanLawApi, matterManager) {
  $scope.accounts = [];
  $scope.me = {};
  $scope.date = new Date();
  $scope.amount = $stateParams.amount || 0;
  $scope.max = isNaN($stateParams.max) ? 99999999 : $stateParams.max;
  if ($scope.max < $scope.amount) {
    $scope.originalAmount = $scope.amount;
    $scope.amount = $scope.max;
  }
  $scope.inputFocus = !$scope.amount;
  $scope.invoices = $stateParams.invoices;
  $scope.description = "";
  activate();
  $scope.save = save;
  $scope.cancel = function () {
    $state.go('^');
  };

  //////////////////

  function activate() {
    $scope.matter = $scope.clientMatter ? $scope.clientMatter.matter : $scope.matter;
    $scope.client = $scope.clientMatter ? $scope.clientMatter.client : $scope.client;
    if ($stateParams.matterId) {
      matterManager.get($stateParams.matterId).then(matter => {
        $scope.matter = matter;
      });
    }
    if (!$scope.matter && !$scope.client && !$stateParams.matterId) {
      throw "Requires client or matter or clientMatter in parent scope";
    }
    userService.me().then(me => {
      $scope.me = me;
    });
    $scope.description = `Payment of invoice${$scope.invoices.length > 1 ? 's' : ''}`;
    const numbers = $scope.invoices.map(i => i.reference);
    if (numbers.length) {
      $scope.description += ` ${numbers.join(', ')}`;
    }
  }
  function save() {
    if (!$scope.amount || !$scope.date) {
      return;
    }
    const billClient = $scope.client && $scope.client.billing.billClient;
    const request = {
      id: billClient ? $scope.client.id : $scope.matter.id,
      body: {
        amount: $scope.amount,
        date: $scope.date,
        invoices: $scope.invoices.map(i => i.id),
        trust: true,
        description: $scope.description
      }
    };
    $scope.saving = true;
    const api = billClient ? leanLawApi.createClientPayment(request) : leanLawApi.createMatterPayment(request);
    api.then(payment => {
      const id = billClient ? $scope.client.billing.trust.account.id : $scope.matter.billing.trust.account.id;
      return accountingService.getAccount(id).then(trust => {
        // reloads balance in parent scope
        if ($scope.trust) {
          $scope.trust.balance = trust.balance;
        }
        $state.go('^', {}, {
          reload: true
        });
      });
    }).catch(err => {
      $scope.saving = false;
      $scope.message = `Failed to record deposit: ${err.body.message}`;
    });
  }
}]);